<template lang="html">
  <div class="modal-footer flex-box">
    <div class="cancel-section">
       <SymbiumButton
        :text="leftActionText"
        :onClick="cancel"
        :loading="leftActionLoading"
        :isSmall="true"
        :isDialog="true"
        v-if="!hideLeftAction"
      />
    </div>

    <SymbiumButton
      :text="rightActionText"
      :onClick="save"
      :loading="rightActionLoading"
      :isSmall="true"
    />
  </div>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  props: {
    'save': {
      type: Function,
      default: () => {}
    },
    'cancel': {
      type: Function,
      default: () => {}
    },
    'rightActionText': {
      type: String,
      default: 'Save'
    },
    'leftActionText': {
      type: String,
      default: 'Cancel'
    },
    'alert': {
      type: Boolean,
      default: false
    },
    leftActionLoading: {
      type: Boolean,
      default: false
    },
    rightActionLoading: {
      type: Boolean,
      default: false
    },
    hideLeftAction: {
      type: Boolean,
      default: false
    }
  },
  components: { SymbiumButton }
}
</script>

<style lang="scss" scoped>
.modal-footer {
  .oval-button {
    float: none;
    font-family: Inter;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.07px;
    padding: 8px 16px;
  }

  .cancel-section {
    flex-grow: 1;
    text-align: left;
  }

  .submit-room-select {
    min-width: 96px;
  }
}
</style>
